import { composeClassNames, getImageUrl } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { Alert } from "react-bootstrap";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import FormJoinUs from "src/components/FormJoinUs";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Heading from "src/components/Heading";
import Page from "src/components/Page";
import Paragraph from "src/components/Paragraph";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getOg from "src/functions/getOg";
import gutter from "src/functions/gutter";
import translate from "src/functions/translate";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sPageJoinUs } from "src/styles/sPageJoinUs.module.scss";

export default function Join_us() {
  const { locale: lang } = useRouter();

  const ogData = getOg(
    lang,
    `website`,
    translate(`Anandita – join us!`, lang),
    translate(
      `Yoga instructor, studio or festival? Join and get 500 CZK for promotion.`,
      lang
    ),
    (function () {
      switch (lang) {
        case `cs`:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/anandita-social-joinus-cs.png")
          );
        case `sk`:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/anandita-social-joinus-sk.png")
          );
        default:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/anandita-social-joinus-en.png")
          );
      }
    })()
  );

  return (
    <>
      <Headers data={ogData} />

      <Page className={composeClassNames([sPageJoinUs, "page-joinus"])}>
        <Header />
        <Content fluid={`xl`}>
          <Heading type={`h1`} title={<Translate tKey={`Join us`} />} />
          <Alert variant={`primary`} className={sAlert}>
            <Heading
              type={`h4`}
              title={
                <>
                  <Translate
                    tKey={`Are you an instructor, yoga studio or festival? Join us and get a contribution for the promotion of your profile on social networks in the amount of`}
                  />
                  {` `}
                  {constants.Marketing.contribution}
                  {` `}
                  <Translate tKey={`CZK`} />
                  {`.`}
                </>
              }
            />
            <Paragraph style={gutter(`margin`, `vertical`, `0`)}>
              <Translate
                tKey={`The offer is valid only for the first 150 profiles.`}
              />
              {` `}
              <Translate tKey={`Currently`} />
              {` `}
              {constants.Marketing.unspentBonuses}
              {` `}
              <Translate tKey={`bonuses remains unspent.`} />
            </Paragraph>
          </Alert>
          <FormJoinUs />
        </Content>
        <Footer />
      </Page>
    </>
  );
}
